export default __webpack_public_path__ + "static/media/case2.2f1175ec.png";